<template>
    <gestion>
        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
            <section aria-labelledby="plan_heading">
                <form @submit.prevent="savePlan">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                            <div>
                                <h2 id="plan_heading" class="text-lg leading-6 font-medium text-gray-900">
                                    {{ $t('gestion.account.plan.title') }}
                                </h2>
                            </div>

                            <fieldset>
                                <legend class="sr-only">
                                    {{ $t('gestion.account.plan.title') }}
                                </legend>
                                <ul class="space-y-4" role="radiogroup" aria-labelledby="radiogroup-label">
                                    <li
                                        id="radiogroup-option-0"
                                        tabindex="0"
                                        role="radio"
                                        aria-checked="true"
                                        class="group relative bg-white rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500"
                                        @click="plan.plan_id = 1"
                                    >
                                        <div class="rounded-lg border border-gray-300 bg-white px-6 py-4 hover:border-gray-400 sm:flex sm:justify-between">
                                            <div class="flex items-center">
                                                <div class="text-sm">
                                                    <p class="font-medium text-gray-900">
                                                        {{ $t('gestion.account.plan.plans.1.name') }}
                                                    </p>
                                                    <div class="text-gray-500">
                                                        <p>
                                                            {{ $t('gestion.account.plan.plans.1.detail') }}
                                                        </p>
                                                        <p class="text-xs">
                                                            {{ $t('gestion.account.plan.plans.1.detail2') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                                                <div class="font-medium text-gray-900">
                                                    0 $
                                                </div>
                                                <div class="ml-1 text-gray-500 sm:ml-0">
                                                    /mois
                                                </div>
                                            </div>
                                        </div>
                                        <div class="absolute inset-0 rounded-lg border-2 pointer-events-none" aria-hidden="true" :class="plan.plan_id == 1 ? 'border-indigo-500' : 'border-transparent'" />
                                    </li>

                                    <li
                                        id="radiogroup-option-1"
                                        tabindex="-1"
                                        role="radio"
                                        aria-checked="false"
                                        class="group relative bg-white rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500"
                                        @click="plan.plan_id = 2"
                                    >
                                        <div class="rounded-lg border border-gray-300 bg-white px-6 py-4 hover:border-gray-400 sm:flex sm:justify-between">
                                            <div class="flex items-center">
                                                <div class="text-sm">
                                                    <p class="font-medium text-gray-900">
                                                        {{ $t('gestion.account.plan.plans.2.name') }}
                                                    </p>
                                                    <div class="text-gray-500">
                                                        <p class="sm:inline">
                                                            {{ $t('gestion.account.plan.plans.2.detail') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                                                <div class="font-medium text-gray-900">
                                                    5 $
                                                </div>
                                                <div class="ml-1 text-gray-500 sm:ml-0">
                                                    /mois
                                                </div>
                                            </div>
                                        </div>
                                        <div class="absolute inset-0 rounded-lg border-2 pointer-events-none" aria-hidden="true" :class="plan.plan_id == 2 ? 'border-indigo-500' : 'border-transparent'" />
                                    </li>

                                    <li
                                        id="radiogroup-option-2"
                                        tabindex="-1"
                                        role="radio"
                                        aria-checked="false"
                                        class="group relative bg-white rounded-lg shadow-sm cursor-pointer focus:outline-none focus:ring-1 focus:ring-offset-2 focus:ring-indigo-500"
                                        @click="plan.plan_id = 3"
                                        v-if="account.plan_id == 3"
                                    >
                                        <div class="rounded-lg border border-gray-300 bg-white px-6 py-4 hover:border-gray-400 sm:flex sm:justify-between">
                                            <div class="flex items-center">
                                                <div class="text-sm">
                                                    <p class="font-medium text-gray-900">
                                                        {{ $t('gestion.account.plan.plans.3.name') }}
                                                    </p>
                                                    <div class="text-gray-500">
                                                        <p class="sm:inline">
                                                            {{ $t('gestion.account.plan.plans.3.detail') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                                                <div class="font-medium text-gray-900">
                                                    7 $
                                                </div>
                                                <div class="ml-1 text-gray-500 sm:ml-0">
                                                    /mois
                                                </div>
                                            </div>
                                        </div>
                                        <div class="absolute inset-0 rounded-lg border-2 pointer-events-none" aria-hidden="true" :class="plan.plan_id == 3 ? 'border-indigo-500' : 'border-transparent'" />
                                    </li>
                                </ul>
                            </fieldset>

                            <toogle :disabled="plan.plan_id == 3" v-model="plan.plan_annual" v-if="plan.plan_id != 1">
                                {{ $t('gestion.account.plan.annual') }}
                            </toogle>

                            <ui-input
                                name="facebook"
                                :label="$t('gestion.account.plan.domain')"
                                :sub-label="$t('gestion.account.plan.domain_detail')"
                                v-model="plan.domain"
                            >
                                <div class="text-sm text-red-500" v-if="plan.errors.domain">
                                    {{ $t(plan.errors.domain[0]) }}
                                </div>
                            </ui-input>
                        </div>
                        <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
                            <activix-button :loading="plan.processing" color="indigo" type="submit">
                                {{ $t('forms.button.save') }}
                            </activix-button>
                        </div>
                    </div>
                </form>
            </section>

            <section aria-labelledby="payment_details_heading" v-if="account.plan_id != 1">
                <form @submit.prevent="savePayment">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white py-6 px-4 sm:p-6">
                            <div>
                                <h2 id="payment_details_heading" class="text-lg leading-6 font-medium text-gray-900">
                                    {{ $t('gestion.account.payment.title') }}
                                </h2>
                            </div>

                            <div class="mt-6">
                                <ul class="border border-gray-200 rounded-md divide-y divide-gray-200" v-if="!showPaymentForm">
                                    <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                        <div class="w-0 flex-1 flex items-center">
                                            <svg
                                                class="flex-shrink-0 h-5 w-5 text-gray-400"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5px"
                                            ><defs /><title>credit-card-1</title><rect
                                                x="0.75"
                                                y="3.75"
                                                width="22.5"
                                                height="16.5"
                                                rx="1.5"
                                                ry="1.5"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            /><line
                                                x1="0.75"
                                                y1="8.25"
                                                x2="23.25"
                                                y2="8.25"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            /><line
                                                x1="5.25"
                                                y1="12.75"
                                                x2="13.5"
                                                y2="12.75"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            /><line
                                                x1="5.25"
                                                y1="15.75"
                                                x2="10.5"
                                                y2="15.75"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            /></svg>
                                            <span class="ml-2 flex-1 w-0 truncate">
                                                {{ $t('gestion.account.payment.end_by', {card: account.card_last_four}) }}
                                            </span>
                                        </div>
                                        <div class="ml-4 flex-shrink-0 flex space-x-4">
                                            <button type="button" class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="editPayment">
                                                {{ $t('gestion.account.payment.update') }}
                                            </button>
                                            <span class="text-gray-300" aria-hidden="true">|</span>
                                            <button type="button" class="bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="removePayment">
                                                {{ $t('gestion.account.payment.remove') }}
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                                <template v-if="showPaymentForm">
                                    <card
                                        class="w-full p-1 pl-2 border border-gray-300 rounded-md"
                                        :stripe="stripeKey"
                                        @change="cardValid = $event.complete"
                                    />
                                </template>
                            </div>
                        </div>
                        <div class="flex px-4 py-3 bg-gray-50 text-right sm:px-6" :class="haveCreditCard ? 'justify-between' : 'justify-end'" v-if="showPaymentForm">
                            <activix-button color="white" @click="cancelEditPayment" v-if="haveCreditCard">
                                {{ $t('forms.button.cancel') }}
                            </activix-button>
                            <activix-button
                                :loading="cardLoading"
                                :disabled="!cardValid"
                                color="indigo"
                                type="submit"
                            >
                                {{ $t('forms.button.save') }}
                            </activix-button>
                        </div>
                    </div>
                </form>
            </section>

            <section aria-labelledby="billing_history_heading" v-if="!!invoices.length">
                <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 sm:px-6">
                        <h2 id="billing_history_heading" class="text-lg leading-6 font-medium text-gray-900">
                            {{ $t('gestion.account.billing.title') }}
                        </h2>
                    </div>
                    <div class="mt-6 flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="overflow-hidden border-t border-gray-200">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                            <tr>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    {{ $t('gestion.account.billing.date') }}
                                                </th>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    {{ $t('gestion.account.billing.description') }}
                                                </th>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    {{ $t('gestion.account.billing.amount') }}
                                                </th>
                                                <!--
                                              `relative` is added here due to a weird bug in Safari that causes `sr-only` headings to introduce overflow on the body on mobile.
                                            -->
                                                <th scope="col" class="relative px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    <span class="sr-only">{{ $t('gestion.account.billing.view') }}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="bg-white divide-y divide-gray-200">
                                            <tr
                                                :key="invoice.id"
                                                v-for="invoice in invoices"
                                            >
                                                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                    {{ invoice.date }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {{ $t('gestion.account.billing.subscription') }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {{ invoice.total }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                    <a :href="$route('gestion.invoice', [account.sid, invoice.id])" class="text-orange-600 hover:text-orange-900">{{ $t('gestion.account.billing.view') }}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <confirmation :is-open.sync="removePaymentConfirm" :title="$t('general.areyousur')">
            <p class="text-sm text-gray-500">
                {{ $t('gestion.account.payment.remove_confirmation') }}
            </p>

            <template #button>
                <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" @click="removePaymentConfirmed">
                    {{ $t('forms.button.delete') }}
                </button>
                <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm" @click="removePaymentConfirm = false">
                    {{ $t('forms.button.cancel') }}
                </button>
            </template>
        </confirmation>
    </gestion>
</template>

<script>
    import { Card, createPaymentMethod } from 'vue-stripe-elements-plus';
    import Gestion from '@/layouts/Gestion.vue';
    import Toogle from '@/components/ui/Toogle.vue';
    import ActivixButton from '@/components/ui/ActivixButton.vue';
    import UiInput from '@/components/ui/UiInput.vue';
    import Confirmation from '@/components/modals/Confirmation.vue';

    export default {
        components: {
            Confirmation,
            ActivixButton,
            UiInput,
            Toogle,
            Gestion,
            Card,
        },

        props: {
            account: {
                type: Object,
                default: () => {},
            },
            invoices: {
                type: Array,
                default: () => [],
            },
            subscribed: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                cardValid: false,
                cardLoading: false,
                stripeKey: process.env.MIX_STRIPE_KEY,
                stripeOptions: {
                    locale: this.$i18n.locale,
                },
                plan: this.$inertia.form({
                    plan_id: this.account.plan_id,
                    plan_annual: this.account.plan_annual,
                    domain: this.account.domain,
                }),
                updatePayment: false,
                removePaymentConfirm: false,
            };
        },

        computed: {
            showPaymentForm() {
                return this.updatePayment || !this.account.card_last_four;
            },

            haveCreditCard() {
                return !!this.account.card_last_four;
            },
        },

        watch: {
            'plan.plan_id'() {
                if (this.plan.plan_id == 3) {
                    this.plan.plan_annual = true;
                }
            },
        },

        methods: {
            editPayment() {
                this.updatePayment = true;
            },

            removePayment() {
                this.removePaymentConfirm = true;
            },

            removePaymentConfirmed() {
                this.$inertia.delete(this.$route('gestion.account.destroy', this.account.sid));
                this.removePaymentConfirm = false;
            },

            cancelEditPayment() {
                this.updatePayment = false;
            },

            savePayment() {
                this.cardLoading = true;
                createPaymentMethod('card', {})
                    .then(data => {
                        this.$inertia
                            .put(this.$route('gestion.account.update', this.account.sid), {
                                section: 'payment',
                                payment_method: data.paymentMethod.id,
                            }, {
                                onSuccess: () => {
                                    this.updatePayment = false;
                                    this.cardLoading = false;
                                    this.$notify.success(this.$t('general.editsaved'));
                                },
                            });
                    })
                    .catch(() => {
                        this.cardLoading = false;
                    });
            },

            savePlan() {
                this.plan
                    .transform((data) => ({
                        ...data,
                        section: 'plan',
                    }))
                    .put(this.$route('gestion.account.update', this.account.sid), {
                        onSuccess: () => this.$notify.success(this.$t('general.editsaved')),
                    });
            },
        },
    };
</script>
